module.exports = __webpack_public_path__ + "assets/img/7b5057554ee9e03a85ca4a7dc6aa0a2c.png";